// Generated by GitHub Copilot - Aug-25-2026
// Predefined dropdown values for issue bulk-upload validation.

// ── Review Type ───────────────────────────────────────────────────────────────

export enum ReviewType {
  StandardReview = 'Standard Review',
  GoLiveReview = 'Go-Live',
  OnDemandReview = 'On Demand',
  SpecialProjectReview = 'Special Project',
}

export const REVIEW_TYPE_ID_MAP: Readonly<Record<string, number>> = {
  [ReviewType.StandardReview]: 1,
  [ReviewType.GoLiveReview]: 2,
  [ReviewType.OnDemandReview]: 3,
  [ReviewType.SpecialProjectReview]: 4,
};

export const REVIEW_TYPE_OPTIONS: readonly ReviewType[] = Object.values(ReviewType);

// ── Issue Rating ──────────────────────────────────────────────────────────────

export enum BulkUploadIssueRating {
  Red = 'Red',
  Yellow = 'Yellow',
  Blue = 'Blue',
  Green = 'Green',
  NotRated = 'Not Rated',
}

export const BULK_UPLOAD_ISSUE_RATING_OPTIONS: readonly BulkUploadIssueRating[] = Object.values(BulkUploadIssueRating);

// ── Report Status ─────────────────────────────────────────────────────────────

export enum BulkUploadReportStatus {
  FinalPublished = 'Final-Published',
  DraftNotPublished = 'Draft-Not Published',
  PreGoLive = 'Pre-Go Live',
}

export const BULK_UPLOAD_REPORT_STATUS_OPTIONS: readonly BulkUploadReportStatus[] = Object.values(BulkUploadReportStatus);

// ── Action Plan Status ────────────────────────────────────────────────────────

export enum BulkUploadActionPlanStatus {
  Open = 'Open',
  OpenAgeingStatic = 'Open Ageing & Static',
  Closed = 'Closed',
  ClosedBlueNotTracked = 'Closed-Blue Not Tracked',
}

export const BULK_UPLOAD_ACTION_PLAN_STATUS_OPTIONS: readonly BulkUploadActionPlanStatus[] = Object.values(BulkUploadActionPlanStatus);

// ── Action Required By ────────────────────────────────────────────────────────

export enum BulkUploadActionRequiredBy {
  AccentureAndClient = 'Accenture & Client',
  Accenture = 'Accenture',
  Client = 'Client',
}

export const BULK_UPLOAD_ACTION_REQUIRED_BY_OPTIONS: readonly BulkUploadActionRequiredBy[] = Object.values(BulkUploadActionRequiredBy);

// ── RepLetter Conflict ────────────────────────────────────────────────────────

export enum BulkUploadRepLetterConflict {
  Yes = 'Yes',
  No = 'No',
  NotApplicable = 'Not Applicable',
}

export const BULK_UPLOAD_REP_LETTER_CONFLICT_OPTIONS: readonly BulkUploadRepLetterConflict[] = Object.values(BulkUploadRepLetterConflict);



// ── Is this issue from Go-Live? ───────────────────────────────────────────────

export const BULK_UPLOAD_ISSUE_FROM_GO_LIVE_OPTIONS: readonly string[] = [
  'Pre-Go Live',
  'Post Go Live',
  'Pre-Go Live&Post Go Live',
];

// ── Yes / No ──────────────────────────────────────────────────────────────────

export const YES_NO_OPTIONS: readonly string[] = ['Yes', 'No'];
